import React, { useEffect, useState } from 'react';
import mainBgImage from '../../../assets/images/sign-up-bg-cover.svg';
import iconImage from '../../../assets/images/icons/logo-ignition-auto-lanka.webp'
import { Link } from 'react-router-dom';
import { getBusinessDetails, setMobileNavbarOpen } from '../../../store/actions';
import { useAppDispatch } from '../../../store';
import { useSelector } from 'react-redux';
import AuthHandler from '../../../helper/AuthHandler';
import Auth from '../../../models/response/auth.model';

type Props = {
  auth: Auth;
}

function SettingsSideBar({ auth }: Props) {

  const routeName = window.location.pathname.split('/')[2];;
  const dispatch = useAppDispatch();
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const { navbarOpen } = useSelector<any, any>((state) => state.settings);;
  const [screenWidth, setWidth] = useState(window.innerWidth);

  const setting = useSelector<any, any>(({ settings }) => settings);

  const {
    userDetails
  } = useSelector<any, any>(({ user }) => user);

  const [businessDetailsData, setBusinessDetailsData] = useState({
    businessName: "",
    businessAddressCity: "",
    logo: ""
  });

  useEffect(() => {
    setBusinessDetailsData({
      ...businessDetailsData,
      businessName: setting.businessDetails ? setting.businessDetails.businessName : "",
      businessAddressCity: setting.businessDetails ? setting.businessDetails.businessAddressCity : "",
      logo: setting.businessDetails ? setting.businessDetails.logo : ""
    })
  }, [setting.businessDetails])

  useEffect(() => {
    let route = window.location.pathname.split('/')[1];
    const tenantGroupId = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
    if (route === 'settings') {
      if (tenantGroupId) {
        dispatch<any>(getBusinessDetails(tenantGroupId));
      }
    }
  }, [userDetails])

  useEffect(() => {
    window.addEventListener("resize", () => setWidth(window.innerWidth));
    if (screenWidth >= 768) {
      setIsNavbarOpen(true);
    } else {
      setIsNavbarOpen(true);
      if (navbarOpen) {
        setIsNavbarOpen(true);
      } else {
        setIsNavbarOpen(false);
      }
    }
  }, [])

  const onHandleLinkClick = () => {
    if (screenWidth < 768) {
      dispatch(setMobileNavbarOpen(false));
      setIsNavbarOpen(false);
    }
  }

  // console.log("businessDetailsData", businessDetailsData);

  return (
      <React.Fragment>
        {isNavbarOpen ?
            (<div className="sub-nav-inner-container__wrapper">
                  <div className="sub-nav-inner-container sub-nav show">
                    <div className="listed-business-preview__wrapper card" style={{ backgroundImage: `url(${mainBgImage})` }}>
                      <div className="profile-placeholder__wrapper left-align business-placeholder__wrapper">
                        <div className="business-img-holder sm" style={{ backgroundImage: `url(${businessDetailsData.logo})` }}>
                        </div>
                        <div className="profile-details">
                          <span className="main-title mt-bg">{businessDetailsData.businessName}</span>
                          <span className="sub-title">{businessDetailsData.businessAddressCity}</span>
                        </div>
                      </div>
                    </div>
                    <nav className="sub-nav-side-bar card">
                      <div className="menu-bar">
                        <div className="manu__wrapper">
                          <div className="menu-link__wrapper">
                            <ul className="menu-links">
                              {AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                                  <li className={(routeName === 'business-details' ? "nav-link active" : "nav-link")} area-label >
                                    <Link to="/settings/business-details" onClick={() => onHandleLinkClick()}>
                            <span className="nav-icon">
                              <span className="idea-icon">
                                {/*?xml version="1.0" encoding="UTF-8"?*/}
                                <svg width="18px" height="19px" viewBox="0 0 18 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                  <title>icon-shop</title>
                                  <g id="Marketing-material's" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                    <g id="ideaicon" transform="translate(-656.000000, -798.000000)" fill="#6C757D" fillRule="nonzero" className="ideaicon">
                                      <path d="M672.8,807.56868 L672.8,815.47668 C672.8,815.80668 672.53,816.07668 672.2,816.07668 L657.8,816.07668 C657.47,816.07668 657.2,815.80668 657.2,815.47668 L657.2,807.56868 C657.386034,807.63457 657.59,807.676625 657.8,807.676625 C658.01,807.676625 658.213973,807.634707 658.4,807.56868 L658.4,814.87668 L659.6,814.87668 L659.6,809.47668 C659.6,809.14668 659.87,808.87668 660.2,808.87668 L663.8,808.87668 C664.13,808.87668 664.4,809.14668 664.4,809.47668 L664.4,814.87668 L671.6,814.87668 L671.6,807.56868 C671.786034,807.63457 671.99,807.676625 672.2,807.676625 C672.41,807.676625 672.613973,807.634707 672.8,807.56868 Z M669.8,808.27668 C670.131341,808.27668 670.4,808.60802 670.4,808.87668 L670.4,812.47668 C670.4,812.80802 670.131341,813.07668 669.8,813.07668 L666.2,813.07668 C665.868659,813.07668 665.6,812.745339 665.6,812.47668 L665.6,808.87668 C665.6,808.545339 665.868659,808.27668 666.2,808.27668 L669.8,808.27668 Z M672.182171,798.532714 C672.116144,798.262714 671.876144,798.07668 671.600103,798.07668 L658.400103,798.07668 C658.124075,798.07668 657.884069,798.262707 657.818034,798.532714 L657.032,801.67668 L672.968,801.67668 L672.181966,798.532714 L672.182171,798.532714 Z M656,803.47668 L656,804.67668 C656,805.66668 656.81,806.47668 657.8,806.47668 C658.262069,806.47668 658.682069,806.29668 659,806.008748 C659.317945,806.296693 659.737931,806.47668 660.2,806.47668 C660.662069,806.47668 661.082069,806.29668 661.4,806.008748 C661.717945,806.296693 662.137931,806.47668 662.6,806.47668 C663.062069,806.47668 663.482069,806.29668 663.8,806.008748 C664.117945,806.296693 664.537931,806.47668 665,806.47668 C665.462069,806.47668 665.882069,806.29668 666.2,806.008748 C666.517945,806.296693 666.937931,806.47668 667.4,806.47668 C667.862069,806.47668 668.282069,806.29668 668.6,806.008748 C668.917945,806.296693 669.337931,806.47668 669.8,806.47668 C670.262069,806.47668 670.682069,806.29668 671,806.008748 C671.317945,806.296693 671.737931,806.47668 672.2,806.47668 C673.19,806.47668 674,805.66668 674,804.67668 L674,803.47668 C674,803.14668 673.73,802.87668 673.4,802.87668 L656.6,802.87668 C656.27,802.87668 656,803.14668 656,803.47668 Z" id="icon-shop" />
                                    </g>
                                  </g>
                                </svg>
                              </span>
                            </span>
                                      <span className="nav-text">Business Details</span>
                                    </Link>
                                  </li>
                              }
                              {!(auth?.realmRoles.includes('mp_content_generator')) && AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                                  <li className={(routeName === 'profile-and-user-permission' ? "nav-link active" : "nav-link")} area-label>
                                    <Link to="/settings/profile-and-user-permission" onClick={() => onHandleLinkClick()}>
                                      <span className="nav-icon"><i className="bi bi-person-badge" /></span>
                                      <span className="nav-text">Profile &amp; User permission</span>
                                    </Link>
                                  </li>
                              }
                              {!(auth?.realmRoles.includes('mp_content_generator')) && AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                                  <li className={(routeName === 'added-apps' ? "nav-link active" : "nav-link")} area-label>
                                    <Link to="/settings/added-apps" onClick={() => onHandleLinkClick()}>
                            <span className="nav-icon">
                              <span className="idea-icon">
                                {/*?xml version="1.0" encoding="UTF-8"?*/}
                                <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                  <title>icon-apps</title>
                                  <defs>
                                    <path d="M637.504727,798.265079 L634.7241,798.265079 C633.191418,798.265079 631.943473,799.514118 631.943473,801.048142 L631.943473,803.831204 C631.943473,805.365228 633.191418,806.614267 634.7241,806.614267 L637.504727,806.614267 C639.037409,806.614267 640.285354,805.365228 640.285354,803.831204 L640.285354,801.048142 C640.285354,799.514118 639.037409,798.265079 637.504727,798.265079 Z M649.193844,800.641202 L647.381195,798.826965 C646.381317,797.826211 644.755028,797.826958 643.755896,798.826965 L641.943247,800.641202 C640.943369,801.641956 640.943369,803.268922 641.943247,804.269676 L643.755896,806.083913 C644.755774,807.084667 646.381317,807.084667 647.381195,806.083913 L649.193844,804.269676 C650.192976,803.269669 650.193722,801.641956 649.193844,800.641202 Z M637.504727,807.727492 L634.7241,807.727492 C633.190274,807.727492 631.943473,808.975385 631.943473,810.510555 L631.943473,813.293617 C631.943473,814.828786 633.190274,816.07668 634.7241,816.07668 L637.504727,816.07668 C639.038553,816.07668 640.285354,814.828786 640.285354,813.293617 L640.285354,810.510555 C640.285354,808.975385 639.038553,807.727492 637.504727,807.727492 Z M646.958859,807.727492 L644.178232,807.727492 C642.644406,807.727492 641.397605,808.975385 641.397605,810.510555 L641.397605,813.293617 C641.397605,814.828786 642.644406,816.07668 644.178232,816.07668 L646.958859,816.07668 C648.492684,816.07668 649.739486,814.828786 649.739486,813.293617 L649.739486,810.510555 C649.739486,808.975385 648.492684,807.727492 646.958859,807.727492 Z" id="path-1" />
                                  </defs>
                                  <g id="Marketing-material's" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                    <g id="ideaicon" transform="translate(-631.000000, -798.000000)">
                                      <mask id="mask-2" fill="white">
                                        <use xlinkHref="#path-1" />
                                      </mask>
                                      <use id="icon-apps" fill="#6C757D" fillRule="nonzero" xlinkHref="#path-1" className="ideaicon" />
                                    </g>
                                  </g>
                                </svg>
                              </span>
                            </span>
                                      <span className="nav-text">Manage Apps</span>
                                    </Link>
                                  </li>
                              }
                              {!(auth?.realmRoles.includes('mp_content_generator')) && AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                                  <li className={(routeName === 'billing-and-plans' ? "nav-link active" : "nav-link")} area-label>
                                    <Link to="/settings/billing-and-plans" onClick={() => onHandleLinkClick()}>
                                      <span className="nav-icon"><i className="bi bi-receipt" /></span>
                                      <span className="nav-text">Billing &amp; Plans</span>
                                    </Link>
                                  </li>
                              }
                              {!(auth?.realmRoles.includes('mp_content_generator')) && AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                                  <li className={(routeName === 'number-configures' ? "nav-link active" : "nav-link")} area-label>
                                    <Link to="/settings/number-configures" onClick={() => onHandleLinkClick()}>
                                      <span className="nav-icon"><i className="bi bi-sliders" /></span>
                                      <span className="nav-text">Manage Numbers</span>
                                    </Link>
                                  </li>
                              }
                              {!(auth?.realmRoles.includes('mp_content_generator')) && AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                                  <li className={(routeName === 'payment' ? "nav-link active" : "nav-link")} area-label>
                                    <Link to="/settings/payment" onClick={() => onHandleLinkClick()}>
                                      <span className="nav-icon"><i className="bi bi-wallet-fill" /></span>
                                      <span className="nav-text">Payment Methods</span>
                                    </Link>
                                  </li>
                              }
                              {AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                                  <li className={(routeName === 'document-and-terms' ? "nav-link active" : "nav-link")} area-label>
                                    <Link to="/settings/document-and-terms" onClick={() => onHandleLinkClick()}>
                                      <span className="nav-icon"><i className="bi bi-file-text-fill" /></span>
                                      <span className="nav-text">Documents &amp; Terms</span>
                                    </Link>
                                  </li>
                              }
                              {AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                                  <li className={(routeName === 'business-brand' ? "nav-link active" : "nav-link")} area-label>
                                    <Link to="/settings/business-brand" onClick={() => onHandleLinkClick()}>
                                      <span className="nav-icon"><i className="bi bi-image-alt" /></span>
                                      <span className="nav-text">Business Brand</span>
                                    </Link>
                                  </li>
                              }
                              {!(auth?.realmRoles.includes('mp_content_generator')) && AuthHandler.isAccessible(auth, 'settings-businesses') &&
                                  <li className={(routeName === 'businesses' ? "nav-link active" : "nav-link")} area-label>
                                    <Link to="/settings/businesses" onClick={() => onHandleLinkClick()}>
                                      <span className="nav-icon"><i className="bi bi-building-fill-gear" /></span>
                                      <span className="nav-text">Businesses</span>
                                    </Link>
                                  </li>}
                              {/* Removed Temporarily */}
                              {/* {AuthHandler.isAccessible(auth, 'settings-owner-tabs') &&
                        <li className={(routeName === 'account' ? "nav-link active" : "nav-link")} area-label>
                          <Link to="/settings/account" onClick={() => onHandleLinkClick()}>
                            <span className="nav-icon"><i className="bi bi-gear-fill" /></span>
                            <span className="nav-text">Account Termination</span>
                          </Link>
                        </li>
                      } */}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
            ) : ("")}
      </React.Fragment>
  );
}

export default SettingsSideBar;